// Remembers the latest request per key (e.g. per product type), so a slower reply to an earlier request can be
// dropped instead of overwriting the newer one (TD1-10685: option group picks and the browser's Back button).
export const createLatestRequestTracker = () => {
  const latest = {};

  return {
    start: (key, id) => {
      latest[key] = id;
    },
    isLatest: (key, id) => latest[key] === id,
  };
};
